/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardThreatsMonth {
    getFixupPrototypeFunction() { return SecurityDashboardThreatsMonth.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardThreatsMonth>): SecurityDashboardThreatsMonth {
        let obj = Object.assign(new SecurityDashboardThreatsMonth(), model);
        SecurityDashboardThreatsMonth.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardThreatsMonth>): SecurityDashboardThreatsMonth {
        if (!model) return null;
        return SecurityDashboardThreatsMonth.newInstance(<SecurityDashboardThreatsMonth> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardThreatsMonth) {
        if (!obj) return;

        models.SecurityDashboardThreatsMonth.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardThreatsMonth): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardThreatsMonth.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.month === "string") {
            this.month = new Date(<string><any>this.month);
        }
        if (this.count_by_severity) {
            models.SecurityDashboardSeverity.fixupPrototype(this.count_by_severity);
        }
    }

    /**
     * Threats Month
     */
    month: Date;

    /**
     * Threats Severity Values
     */
    count_by_severity: models.SecurityDashboardSeverity;

}
